module.exports = __webpack_public_path__ + "img/done.3e5f944f.svg";